import type { DropdownOption } from '../../components/ui/form/FormDropdownField'
import type { CurrentRecordGroup, RecordGroupOption } from './types'

/** Kaydın mevcut grubu seçeneklerde yoksa (pasif grup) devre dışı seçenek olarak eklenir. */
export function recordGroupOptions(
  selectable: RecordGroupOption[],
  current: CurrentRecordGroup | null,
): DropdownOption[] {
  const options: DropdownOption[] = selectable.map((g) => ({ label: g.name, value: g.id }))
  if (current && !selectable.some((g) => g.id === current.id)) {
    options.push({ label: current.name ?? String(current.id), value: current.id, disabled: true })
  }
  return options
}

export function preselectedRecordGroupId(selectable: RecordGroupOption[]): number | null {
  return selectable.length === 1 ? selectable[0].id : null
}
